import { monthNames } from "./constants";
import { getDateFromMonthYear } from "../dates/dateFunc";

const date = new Date();
date.setMonth(date.getMonth());

export const customFilterTypes: CustomFilterType[] = [
  {
    type: "MonthYear",
    direction: "desc",
    fn: getDateFromMonthYear,
    defaultSelected: [`${monthNames[date.getMonth()]} ${date.getFullYear()}`],
  },
];

type CustomFilterType = {
  type: string;
  direction: "asc" | "desc";
  fn: (data: any) => any;
  defaultSelected: string[];
};
